__turbopack_context__.v({
  "articleFilter": "ArticleListingPageBlok-module__yu_HDq__articleFilter",
  "blok-big-title": "ArticleListingPageBlok-module__yu_HDq__blok-big-title",
  "blok-subtitle": "ArticleListingPageBlok-module__yu_HDq__blok-subtitle",
  "blok-title": "ArticleListingPageBlok-module__yu_HDq__blok-title",
  "count": "ArticleListingPageBlok-module__yu_HDq__count",
  "description": "ArticleListingPageBlok-module__yu_HDq__description",
  "featured__article": "ArticleListingPageBlok-module__yu_HDq__featured__article",
  "heading__wrapper": "ArticleListingPageBlok-module__yu_HDq__heading__wrapper",
  "no-border": "ArticleListingPageBlok-module__yu_HDq__no-border",
  "products": "ArticleListingPageBlok-module__yu_HDq__products",
  "root": "ArticleListingPageBlok-module__yu_HDq__root",
  "sort": "ArticleListingPageBlok-module__yu_HDq__sort",
});
